export default __webpack_public_path__ + "static/media/raccelogo1.b1676bc2.jpg";